const store = {
  data: {
    size: 24,
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }
};
function setStore(data = {}, options = {}) {
  store.data = options.override ? data : { ...store.data, ...data };
}
function getStore() {
  return { ...store.data };
}

export { getStore, setStore };
//# sourceMappingURL=index.mjs.map
